import { newToolFilterOAuthMcp } from "../oauth.ts";

export const firefliesMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://fireflies.ai/apple-icon.png",
  url: "https://api.fireflies.ai/mcp",
  label: "Fireflies.ai",
});
